import { render } from "./SelectableFullStar.vue?vue&type=template&id=35d9c1eb&scoped=true"
import script from "./SelectableFullStar.vue?vue&type=script&lang=js"
export * from "./SelectableFullStar.vue?vue&type=script&lang=js"

import "./SelectableFullStar.vue?vue&type=style&index=0&id=35d9c1eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35d9c1eb"]])

export default __exports__